import '../../../css/bem/_quick-basket.scss';
import panelUpdater from '@remarkablenet/panel-updater';
import { getQuickbasketHTML, getQuickBasketCount, getBasketTotal } from './quick-basket-services';
import { removeFromBag, increaseQuantityBasket, decreaseQuantityBasket } from '../bag/bag-services';
import * as CSSTH from '../css-transition-helper/css-transition-helper';
import { displayToast } from '../toastify/toastify';
import { deactivate } from '../css-transition-helper/css-transition-helper';
import { gaTracking } from '../event/event';
import { addOffCanvasPanelListeners } from '../off-canvas-panel/off-canvas-panel';
export interface BasketUpdateQuantity {
    errors: any;
    success: boolean;
    response: BasketUpdateQuantityResponse;
    updatedDataLayer: string;
}

export interface BasketUpdateQuantityResponse {
    basketGuid: any;
    basketLineId: number;
    quantity: number;
    voucherCode: any;
    success: boolean;
    succeeded: boolean;
    errors: BasketUpdateQuantityError[];
}

export interface BasketUpdateQuantityError {
    code: string;
    description: string;
}

let loadTriggered = false;

const DEFAULTS = {
    quickBasket: '.quick-basket',
    quickBasketContent: '.quick-basket__content',
    quickBasketCount: '.js-quick-basket-count',
    basketTotal: '.js-basket-total',
    basketTotalContent: '.basket-total__content'
};

const modifyContent = (elm, html) => {
    elm.innerHTML = html;
};

const scrollbarWidth = window.innerWidth - document.body.clientWidth + 'px';

const closeQuickBasket = (elm) => {
    CSSTH.deactivate(elm);
};

const loadQuickBasket = (elm) => {
    if (loadTriggered) return;
    loadTriggered = true;
    const panel = elm.querySelector('.panel-updater');
    document.querySelectorAll('.js-open-quick-basket').forEach((trigger) =>
        trigger.addEventListener('click', (e) => {
            e.preventDefault();
            updateQuickBasket(panel);
            CSSTH.activate(elm);
            setupCloseQuickbasket(elm);
            gaTracking("view_cart", true);     
            if (document.documentElement.classList.contains('is-rika'))
                setTimeout(() => { addOffCanvasPanelListeners(); }, 1000);
        })
    );
};

const loadQuickBasketAddProduct = (elm, timeout) => {
    const panel = elm.querySelector('.panel-updater');
    if (timeout) elm.onmouseenter = () => clearTimeout(timeout);
    if (elm.classList.contains('is-active')) {
        updateQuickBasket(panel);
        return;
    }
    CSSTH.activate(elm);
    updateQuickBasket(panel);
    setupCloseQuickbasket(elm);
};

const updateQuickBasket = async (elm, count = -1) => {
    if (count === -1 && elm.classList.contains('panel-updater')) {
        const html = await panelUpdater(elm, getQuickbasketHTML());
        modifyContent(elm, html);
        setupQuickbasketIncreaseQuantity(elm);
        setupQuickbasketDecreaseQuantity(elm);
        setupQuickbasketDelete(elm);
        setupQuickbasketInsuranceDelete(elm);
        setupCloseQuickbasket(elm);
    }
    updateQuickBasketCount(count, true);
    updateBasketTotal(true);
};
3;
const quickShowQuickbasket = (elm: HTMLElement) => {
    const closeTimeout = setTimeout(() => {
        closeQuickBasket(elm);
    }, 3000);

    loadQuickBasketAddProduct(elm, closeTimeout);
};

const setupQuickbasketDelete = (elm) => {
    elm.querySelectorAll('.js-quick-basket-item-remove').forEach((item) => {
        const shoppingBasketId = Number(item.dataset.pid);
        item.addEventListener('click', (e) => {
            e.preventDefault();
            const product = item.closest('.associated-product') as HTMLElement;
            const qty = product.querySelector<HTMLSpanElement>('.basket-item__quantity-count').innerText;
            item.innerText = "Removing";
            elm.querySelectorAll('.js-quick-basket-item-remove').forEach((item) => { item.classList.add('disabled'); });
            quickbasketDelete(shoppingBasketId, elm, product, item, qty);
        });
    });
};

const setupQuickbasketInsuranceDelete = (elm) => {
    const removeButtons = elm.querySelectorAll('.js-remove-insurance');
    if (removeButtons) {
        removeButtons.forEach((item: HTMLLinkElement) => {
            item.addEventListener('click', (e) => {
                e.preventDefault();
                item.innerText = "Removing...";
                const url = item.getAttribute('href');
                fetch(url)
                    .then((res) => res.json())
                    .then((data) => {
                        if (data.success) {
                            item.innerText = "Product insurance removed";
                            updateBasketTotal(true);
                            setTimeout(() => { item.parentElement.remove(); }, 3000);
                        } else {
                            item.innerText = 'Error removing product insurance. Please try again';
                            setTimeout(() => { item.innerText = "Click here to remove insurance"; }, 3000);                            
                        }                            
                    })
                    .catch((error) => {
                        return { message: 'server error', error };
                    });
            });
        });
    }
};

const setupQuickbasketIncreaseQuantity = (elm) => {
    elm.querySelectorAll('.js-quick-basket-item-increase').forEach((item) => {
        const shoppingBasketId = item.dataset.basketlineid;
        item.addEventListener('click', (e) => {
            e.preventDefault();
            quickbasketChangeQuantity(parseInt(shoppingBasketId), item.closest('.associated-product'), false);
        });
    });
};

const setupQuickbasketDecreaseQuantity = (elm) => {
    elm.querySelectorAll('.js-quick-basket-item-decrease').forEach((item) => {
        const shoppingBasketId = item.dataset.basketlineid;

        item.addEventListener('click', (e) => {
            e.preventDefault();
            quickbasketChangeQuantity(parseInt(shoppingBasketId), item.closest('.associated-product'), true);
            const product = e.target.closest('.associated-product') as HTMLElement;
            gaTracking("remove_from_cart", false, {
                currency: "GBP",
                value: parseFloat(product.dataset.price),
                items: [
                    {
                        item_id: product.dataset.pid,
                        item_name: product.dataset.title,
                        quantity: 1,
                        price: parseFloat(product.dataset.price),
                        item_brand: product.dataset.brand,
                        item_category: product.dataset.category

                    }
                ]
            });
        });
    });
};

const setupCloseQuickbasket = (elm) => {
    elm.querySelectorAll('.js-close-quick-basket').forEach((item) => {
        item.addEventListener('click', (e) => {
            deactivate(document.querySelector(DEFAULTS.quickBasketContent));
        });
    });
};

export const quickbasketDelete = (id, elm, item, btn = null, qty: string = "1") => {
    removeFromBag(id).then(async (r) => {
        if (r.success) {
            const product = btn.closest('.associated-product') as HTMLElement;
            gaTracking("remove_from_cart", false, {
                currency: "GBP",
                value: parseFloat(product.dataset.price),
                items: [
                    {
                        item_id: product.dataset.pid,
                        item_name: product.dataset.title,
                        quantity: parseInt(product.dataset.qty),
                        price: parseFloat(product.dataset.price),
                        item_brand: product.dataset.brand,
                        item_category: product.dataset.category
                    }
                ]
            });
            var reset = false;            
            let count = await getQuickBasketCount(true);
            const bagButton = document.querySelector('.js-open-quick-basket') as HTMLLinkElement;
            if (elm.classList.contains('panel-updater')) {
                
                item.classList.add('quick-basket-item--fade');
                item.addEventListener('transitionend', () => {
                    if (!reset) {
                        reset = true;
                        if (elm.classList.contains('panel-updater')) {
                            updateQuickBasket(elm, !count ? -1 : count);
                            bagButton?.click();
                        }
                    }
                });
                setTimeout(() => {
                    updateBasketTotal();
                    let basketItemCount = parseInt((document.querySelector('.quick-basket__count') as HTMLElement).innerText);
                    const newCount = basketItemCount - parseInt(qty);
                    updateQuickBasketCount(newCount);                    
                    bagButton?.click();
                    elm.querySelectorAll('.js-quick-basket-item-remove').forEach((item) => {
                        item.innerText = "Remove";
                        item.classList.remove('disabled');
                    });
                }, 500);
            } else {
                if (!count) location.href = '/basket';
                else bagButton?.click();
                elm.querySelectorAll('.js-quick-basket-item-remove').forEach((item) => {
                    item.innerText = "Remove";
                    item.classList.remove('disabled');
                });
            }
        }
    });
};

export const quickbasketChangeQuantity = (id: number, parent: HTMLElement, isDecrease: boolean) => {
    const bagButton = document.querySelector('.js-open-quick-basket') as HTMLLinkElement;
    let input = parent.querySelector<HTMLInputElement>('.js-hidden-qty'),
        currentQuantity = parseInt(input.value),
        newQuantity = isDecrease ? currentQuantity - 1 : currentQuantity + 1,
        action = isDecrease ? decreaseQuantityBasket(id, currentQuantity) : increaseQuantityBasket(id, currentQuantity),
        decreaseBtn = parent.querySelector('.basket-item__quantity-btn.js-quick-basket-item-decrease'),
        qtyBtns = document.querySelectorAll('.basket-item__quantity-btn') as NodeListOf<HTMLElement>;

    qtyBtns.forEach(btn => { btn.classList.add('disabled') });

    action
        .then(async (r: BasketUpdateQuantity) => {
            ResetErrors();
            if (r.success) {
                let currentCount = parseInt(document.querySelector<HTMLSpanElement>('.js-quick-basket-count').innerText);
                input.value = newQuantity.toString();
                parent.querySelector('.js-basket-qty').innerHTML = newQuantity.toString();

                if (newQuantity >= 2) decreaseBtn.classList.remove('hidden');
                else decreaseBtn.classList.add('hidden');

                updateQuickBasket(parent, (isDecrease ? currentCount - 1 : currentCount += 1));
            }
            else displayToast(r.errors[0].description);
            qtyBtns.forEach(btn => { setTimeout(() => { btn.classList.remove('disabled') }, 2000) });

            bagButton?.click();
        });
};

const ResetErrors = () => {
    document.querySelectorAll('.js-quick-basket-errors').forEach((err, index) => {
        if (index) err.remove();
        else {
            err.innerHTML = '';
            err.classList.add('hidden');
        }
    });
};

// preview quickbasket
export const previewQuickbasket = (
    quickBasketContent = DEFAULTS.quickBasketContent,
    quickBasket = DEFAULTS.quickBasket
) => {
    const QUICK_BASKET = document.querySelector(quickBasket);
    const QUICK_BASKET_ELEMENT = QUICK_BASKET.querySelector(quickBasketContent);
    quickShowQuickbasket.bind(null, QUICK_BASKET_ELEMENT)();
};

// quick basket count
export const updateQuickBasketCount = async (count = -1, cacheBuster = false) => {
    if (count === -1) count = await getQuickBasketCount(cacheBuster);
    if (!count) count = 0;
    document.querySelectorAll(DEFAULTS.quickBasketCount).forEach((elm) => {
        modifyContent(elm, count);
    });
    if (count === 0 || typeof (count) != 'number') document.querySelector(DEFAULTS.quickBasketCount).classList.add('d-none');
    else {
        if (document.querySelector(DEFAULTS.quickBasketCount) as HTMLElement) document.querySelector(DEFAULTS.quickBasketCount).classList.remove('d-none');
    }
};

// basket Total
export const updateBasketTotal = async (cacheBuster = false) => {
    let total = await getBasketTotal(cacheBuster);
    const totals = document.querySelectorAll(DEFAULTS.basketTotal);
    totals.forEach((elm) => {
        modifyContent(elm, total);
    });
};

// quick basket init
export const init = (quickBasket = DEFAULTS.quickBasket, quickBasketContent = DEFAULTS.quickBasketContent) => {
    const QUICK_BASKET: HTMLElement = document.querySelector(quickBasket);
    const QUICK_BASKET_ELEMENT = QUICK_BASKET.querySelector(quickBasketContent);
    let debounce;
    QUICK_BASKET.onmouseenter = () => {
        if (QUICK_BASKET_ELEMENT.classList.contains('is-active')) return;
        debounce = window.setTimeout(() => {
            loadQuickBasket(QUICK_BASKET_ELEMENT);
        }, 300);
    };

    QUICK_BASKET.onmouseleave = () => {
        window.clearTimeout(debounce);
    };

    return {
        loadQuickbasket: () => loadQuickBasket.bind(null, QUICK_BASKET_ELEMENT)()
    };
};